import { render, staticRenderFns } from "./UsuarioData.vue?vue&type=template&id=7217fde6&"
import script from "./UsuarioData.vue?vue&type=script&lang=js&"
export * from "./UsuarioData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports